export default __webpack_public_path__ + "static/media/INEFOP_logo.1430978a.png";